import { render, staticRenderFns } from "./gs-raise-now-tamaro.vue?vue&type=template&id=a591b4d0"
import script from "./gs-raise-now-tamaro.vue?vue&type=script&lang=ts"
export * from "./gs-raise-now-tamaro.vue?vue&type=script&lang=ts"
import style0 from "./gs-raise-now-tamaro.vue?vue&type=style&index=0&id=a591b4d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports